import React, { useCallback } from 'react';
import styles from './index.module.css';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useQuery } from '../../hooks/useQuery';
import Typography from '../../design-system/lib/Typography';
import Button from '../../design-system/lib/Button';
import Input from '../../design-system/lib/Input';
import { httpCustomer } from '../../helper/api';
import { snack } from '../../utils/SnackbarUtilsConfigurator';
import passwordIcon from '../../assets/password.svg';
import done_circle from '../../assets/done_circle.svg';
import Axios from 'axios';
import { Helmet } from "react-helmet";




export function  ResetPassword(props) {
  const { t, i18n } = useTranslation();
  const searchParams = useQuery();
  const token = searchParams.get("at");
  const [password, setPassword] = React.useState("");
  const [rpassword, setRpassword] = React.useState("");
  const [loading, setLoading] = React.useState("");
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(false);

    const changePassword = useCallback(() => {
      setLoading(true)
      setError(null)
      Axios
     .post(
       `${global.config.restServerUrl}/api/driver/auth/password-reset`,
       {
          "password": password,
          "confirmPassword": password
       },
       {
         headers: {
           "Accept-Language": "en",
           "Authorization" : `Bearer ${token}`
         },
       }
     )
     .then((res) => {
      setSuccess(true)
      setLoading(false)
      setError(null)
      })
     .catch((error) => {
      setLoading(false)
      setError(error.response.data.message)
      snack.error(error.response.data.message)
     });
    }, [ password , token ]);
  
 
  return <div className={styles.App} style={{justifyContent : success && "center"}} >
      <Helmet>
            <title> {global.config.dispatcherText.title}</title>
            <style type="text/css">{`
           body .changingCssAnimationxx { 
 
      background-color: transparent;

         display: none !important;
         z-index: -1;
}
         `}</style>

        </Helmet>
<div className={styles.Card} >
  {!success ? <>        <img src={passwordIcon} />
        <Typography weight='Heading_Small_Bold' style={{marginTop:"16px"}} text={t("Change password")} />
        <Typography weight='Body_Tiny_Regular'  style={{marginTop:"4px"}} text={t("Enter your new password")} />
        <Input error={(String(password).length < 6 && String(password).length > 0) && t("Password must be at least 6 characters")} onChange={(e)=>{setPassword(e.target.value)}} size='Large' containerStyle={{marginTop:"24px"}} type={"password"} title={t("Password")} placeHolder={t("Type here")} />
        <Input  error={( String(rpassword).length > 0 && String(password).trim() != String(rpassword).trim()) && t("Repeat password doesn’t match")}  onChange={(e)=>{setRpassword(e.target.value)}} size='Large'  containerStyle={{marginTop:"16px"}} type={"password"} title={t("Repeat password")} placeHolder={t("Type here")} />
        <Button isLoading={loading} disabled={String(password).length < 6 || String(rpassword).length < 6 || String(password).trim() != String(rpassword).trim() || loading} onClick={changePassword} style={{marginTop:"24px" ,width:"calc(100% - 32px)" ,maxHeight:"43px" , height:"25px"}} size='Medium' type='Primary' text={t("Change")} />
  
  </> : <>
  <img src={done_circle} />
  <Typography weight='Heading_Small_Bold' style={{marginTop:"16px" ,color :"#009B62"}} text={t("Password changed")} />
  <Typography weight='Body_Middle_Regular'  style={{marginTop:"4px" , color :"#484848"}} text={t("Return to app and login again")} />
  </>}
  </div>
    </div>

}


